import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { DateTime } from 'luxon';
import { Field } from 'formik';
import FormikDatePicker from './FormikDatePicker';

const WhenYouCome = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="sm" className={classes.container}>
      <Typography variant="h3">Quando você vem?</Typography>
      <Typography>Escolha a data que você deseja para a reserva da sua mesa.</Typography>
      <Field
        name="date"
        component={FormikDatePicker}
        className={classes.dateField}
        minDate={DateTime.local().plus({ day: 1 })}
      />
    </Container>
  );
}

export default WhenYouCome;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& h3': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
      },

      '& p': {
        margin: theme.spacing(2, 0, 4),
        maxWidth: '80vw',

        [theme.breakpoints.up('sm')]: {
          margin: theme.spacing(2, 0, 5),
          width: "71%",
        },
        [theme.breakpoints.up('lg')]: {
          width: "65%",
        },
      }
    },
    dateField: {
      [theme.breakpoints.up('sm')]: {
        width: '70%',
      },

      '&:focus': {
        borderColor: theme.palette.primary.light,
      },
      '& label.Mui-focused': {
        color: theme.palette.primary.light,
      },

      '& .MuiInputBase-root': {
        borderRadius: 17,

        '& input': {
          padding: theme.spacing(1.7)
        },
        "& svg": {
          width: '100%',
          height: 'auto',
          maxWidth: 20,
          color: theme.palette.primary.light,
          [theme.breakpoints.up('sm')]: {
            maxWidth: 25,
          },
        },
      },
    },
  })
);